'use strict';

module.exports = /*@ngInject*/
function(
    AnthroConfig,
    LsCache,
    LZString
) {
    /**
     * Force a flush of expired keys to prevent
     * stale entries from overflowing localStorage.
     */
    LsCache.flushExpired();

    /**
     * Set base expiration time to a single millisecond
     * so that expiration can be calculated manually
     * on a per request basis. The reason for this is that
     * LocalStorage is designed to have a single global
     * setting for expiry units. Resetting this every request
     * will cause LocalStorage to be flushed.
     */
    LsCache.setExpiryUnitMs(1);

    return {
        /**
         * Caches a given response for a given cache key in LocalStorage.
         * @param  {String} cacheKey The cache key to cache
         * @param  {Object} data        Data to cache
         * @param  {Object} [options]   Optional LsCache options
         *                              Options takes the following optional attributes:
         *                              {
         *                                    cacheKey: '',     // localStorage cache key
         *                                    compress: true,   // should the cached response be compressed?
         *                                    expiryTime: 1000  // localStorage cache time in milliseconds
         *                              }
         * @return {Object}          Returns the LocalStorageService for chaining purposes.
         */
        cache: function(cacheKey, data, options) {
            var expiryTime;

            options = options || {};

            expiryTime = options.expiryTime || AnthroConfig.cache.defaultExpiryTime;

            if (options.compress) {
                data = JSON.stringify(data);
                data = LZString.compress(data);
            }

            LsCache.set(cacheKey, data, expiryTime);

            return this;
        },

        /**
         * Flushes the entirely of the LocalStorage cache
         * @return {Object} Returns the LocalStorageService for chaining purposes.
         */
        flushCache: function() {
            LsCache.flush();
            return this;
        },

        /**
         * Gets a given key from LocalStorage
         * @param  {String} key         LocalStorage key to retrieve
         * @param  {Object}  [options]  Optional LsCache options
         *                              Options takes the following optional attributes:
         *                              {
         *                                    cacheKey: '',     // localStorage cache key
         *                                    compress: true,   // should the cached response be compressed?
         *                                    expiryTime: 1000  // localStorage cache time in milliseconds
         *                              }
         * @return {String|Object}      Returns a LocalStorage value if key is found; null otherwise.
         */
        getCache: function(key, options) {
            var data = LsCache.get(key, true);

            options = options || {};

            if (data && options.compress) {
                data = LZString.decompress(data);
                data = JSON.parse(data);
            }

            return data;
        },

        /**
         * Is the given key cached?
         * @param  {String}  cacheKey Key for cache
         * @return {Boolean}          True, if key is cached; false, otherwise.
         */
        isCached: function(cacheKey) {
            return !!this.getCache(cacheKey);
        },

        /**
         * Removes a given cache key from the cache
         * @param  {String} cacheKey The cache key to remove from LocalStorage.
         * @return {Object}          Returns the LocalStorageService for chaining purposes.
         */
        removeCache: function(cacheKey) {
            LsCache.remove(cacheKey);
            return this;
        }
    };
};
